import { Component } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    standalone: false
})
export class FooterComponent  {
  
  public today: number = Date.now();

  constructor() { }

  

}
